import React from 'react';
import { useSearchParams } from 'react-router-dom';
import IELTSCourse from '../courses/IELTSCourse';
import { adverbialClausesData, getDataForDifficulty } from '../courses/data/grammar/adverbialClauses';

export default function AdverbialClauseTips() {
  const [searchParams] = useSearchParams();
  const lessonId = searchParams.get('lessonId');
  const difficulty = parseInt(searchParams.get('difficulty')) || 3;

  return (
    <IELTSCourse
      {...(difficulty !== 3 ? getDataForDifficulty(difficulty) : adverbialClausesData)}
      lessonId={lessonId}
      difficulty={difficulty}
    />
  );
}
